function ToolbarExtensions(/* { appState } */) {
	return null;
}

export default ToolbarExtensions;



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/ToolbarExtensions.js